const useCompareValue = (initialValue, newValue) => {
  const hasChanged = JSON.stringify(initialValue) !== JSON.stringify(newValue);
  return hasChanged;
};

export default useCompareValue;
